export interface ICreateInternalContactRequest {
  adminId: string;
  roles: string[];
  phoneExtension?: number;
  timeZone?: string;
  notes?: string;
}

export type ICreateInternalContactData = ICreateInternalContactRequest;

export const convertFromICreateInternalContactDataToICreateInternalContactRequest = (
  data: ICreateInternalContactRequest
): ICreateInternalContactData => data;
